export const DATE_PICKER_FORMATE = {
  parse: {
    dateInput: 'D/MM/YYYY'
  },
  display: {
    dateInput: 'D/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};
